import { ChangeDetectionStrategy, Component, OnInit, ViewChild, computed, inject } from '@angular/core';
import { adminMenu } from 'src/environments/variables';
import { LuxorMenuItem } from 'src/app/shared/interfaces/menuItem.interface';
import { AuthService } from 'src/app/shared/services/auth.service';
import {  Router, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { LuxNotification } from 'src/app/modules/dashboard/interfaces/notification.interface';
import { DividerModule } from 'primeng/divider';
import { CommonModule } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';
import { SpeedDialModule } from 'primeng/speeddial';
import { ButtonModule } from 'primeng/button';
import { SidebarModule } from 'primeng/sidebar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BadgeModule } from 'primeng/badge';
import { Drawer, DrawerModule } from 'primeng/drawer';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { DashboardSidebarComponent } from "../dashboard-sidebar/dashboard-sidebar.component";
import { ThemeToggleBtnComponent } from "../../shared/components/theme-toggle-btn/theme-toggle-btn.component";
import { ThemeService } from 'src/app/shared/services/theme.service';
import { NotificationsPopoverComponent } from "../../modules/dashboard/components/notifications-popover/notifications-popover.component";
import { EmployeeAvatarFichajeInfoComponent } from "../../modules/dashboard/components/employee-avatar-fichaje-info/employee-avatar-fichaje-info.component";

@Component({
    imports: [
    DividerModule,
    CommonModule,
    DividerModule,
    AvatarModule,
    SpeedDialModule,
    ButtonModule,
    SidebarModule,
    FormsModule,
    BadgeModule,
    ReactiveFormsModule,
    DrawerModule,
    RouterModule,
    TieredMenuModule,
    DashboardSidebarComponent,
    ThemeToggleBtnComponent,
    NotificationsPopoverComponent,
    EmployeeAvatarFichajeInfoComponent
],
    selector: 'app-dashboard-topbar',
    standalone: true, 
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './dashboard-topbar.component.html',
    styleUrls: ['./dashboard-topbar.component.scss']
})
export class DashboardTopbarComponent implements OnInit{
  @ViewChild('drawer') drawer!: Drawer; // Referencia al gráfico

  private authService = inject( AuthService );
  private themeService = inject( ThemeService );

  public user = computed(() => this.authService.currentUser() );

  public isDarkTheme = computed(() => this.themeService.darkTheme())

  public actions: MenuItem[] | undefined;

  public role:string;

  public notifications:LuxNotification[] = [];
  constructor(private router:Router) {
  }

  ngOnInit(): void {
    if (this.user()?.role === 'admin') {
      this.actions = [
        {
          icon: 'ri-scales-line',
          label: 'Nueva operación',
          command: () => this.router.navigate(['./app/operations/new/from_sketch']),
          tooltipOptions: {
            tooltipLabel: 'Nueva operación'
        },
        },
        {
          icon: 'ri-folder-user-line',
          label: 'Añadir empleado',
          command: () => this.router.navigate(['./app/employees/new-employee']),
          tooltipOptions: {
            tooltipLabel: 'Añadir empleado'
        },
        },
        {
          icon: 'ri-alarm-warning-fill',
          label: 'Nueva oportunidad',
          command: () => this.router.navigate(['./app/opportunities']),
          tooltipOptions: {
            tooltipLabel: 'Gestionar oportunidades'
        },
        },
      ]
    } else {
      this.actions = [
        {
          label: 'Nueva operación',
          icon: 'ri-scales-line',
          routerLink: ['./operations/new/from_sketch']
        },
      ]
    }

    switch (this.user()?.role) {
      case 'admin':
        this.role = 'Administrador'
        break;
      case 'manager':
        this.role = 'Manager'
        break;
      case 'user':
        this.role = 'Empleado'
        break;

    }
  }
  

  public sidebarVisible:boolean = false;
  public menu:LuxorMenuItem[] = adminMenu;

  closeMenu():void {
    this.sidebarVisible = false;
  }

  handleCloseDrawer(event:any) {
    this.closeCallback(event);
  }


  handleOptionSelected(event:boolean) {
    console.log(this.drawer);
    this.closeCallback(event);
  }

  closeCallback(e:any): void {
    this.drawer.close(e);
}


}



